import CallersInspiredHero from '../components/CallersInspiredHero';
import TrustedBySection from '../components/TrustedBySection';
import FounderVideoSection from '../components/FounderVideoSection';
import HowItWorksSection from '../components/HowItWorksSection';
import RealEstateUseCases from '../components/RealEstateUseCases';
import SingleTestimonialCard from '../components/SingleTestimonialCard';
import IntegrationsListSection from '../components/IntegrationsListSection';
import PricingModelSection from '../components/PricingModelSection';
import SimpleFAQ from '../components/SimpleFAQ';
import FinalCTA from '../components/FinalCTA';
import { homepageFAQs } from '../data/faqData';
import { useSeo } from '../hooks/useSeo';

export default function HomePage() {
  useSeo({
    title: 'AI Lead Follow-up for Real Estate | Point Break Systems',
    description: 'Custom AI callers for Canadian and US real estate teams. Qualify leads, automate follow-up, and book appointments in your CRM on your own accounts.',
    path: '/',
    schemas: [
      { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: homepageFAQs.map(faq => ({
        '@type': 'Question', name: faq.question, acceptedAnswer: { '@type': 'Answer', text: faq.answer }
      })) },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "AI ISA Replacement for Realtors | Point Break Systems",
        "description": "AI ISA replacement for realtors. Every new lead called in 30 seconds. Built on your own accounts with a one-time setup fee and ongoing retainer.",
        "url": "https://pointbreak.systems",
        "mainEntity": {
          "@type": "Organization", "@id": "https://pointbreak.systems/#organization",
          "name": "Point Break Systems"
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://pointbreak.systems"
            }
          ]
        }
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col">
      <CallersInspiredHero />
      <SingleTestimonialCard />
      <TrustedBySection />
      <FounderVideoSection />
      <HowItWorksSection />
      <RealEstateUseCases />
      <IntegrationsListSection />
      <PricingModelSection />
      <SimpleFAQ />
      <FinalCTA />
    </div>
  );
}
